import DOMPurify from 'dompurify';

// Ensure links that open in a new tab are safe
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName && node.tagName.toLowerCase() === 'a') {
    const target = node.getAttribute('target');
    if (target && target.toLowerCase() === '_blank') {
      const existingRel = node.getAttribute('rel') || '';
      const relParts = new Set(existingRel.split(/\s+/).filter(Boolean));
      relParts.add('noopener');
      relParts.add('noreferrer');
      node.setAttribute('rel', Array.from(relParts).join(' '));
    }
  }
});

export function sanitizeHtml(html) {
  if (typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    // Allow only safe URL schemes (block javascript: and data: except images)
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|data:image\/(?:png|jpeg|gif|webp);)/i,
  });
}


